"use client";

import { useEffect } from "react";

function UpdatePopularPost({ postId }) {
  const updatePost = async () => {
    const res = await fetch(`/api/popular-posts`, {
      method: "POST",
      body: JSON.stringify({ id: postId }),
    });
  };

  useEffect(() => {
    updatePost();
  }, [postId]);

  return null;
}

export default UpdatePopularPost;
